import { db } from '../firebase';

/**
 * Fetch all admin documents from the `admins` collection.
 */
export async function getAdmins() {
  const snapshot = await db.collection('admins').orderBy('name').get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

/**
 * Create a new admin document.
 * @param {{ name, email, password, role, permissions: string[] }} data
 */
export async function createAdmin(data) {
  const payload = {
    name: data.name.trim(),
    email: data.email.trim().toLowerCase(),
    password: data.password,
    role: data.role,
    createdAt: new Date().toISOString(),
  };
  if (data.role !== 'admin') {
    payload.permissions = data.permissions;
  }
  const docRef = await db.collection('admins').add(payload);
  return docRef.id;
}

/**
 * Update an existing admin document.
 * @param {string} id  Firestore document ID
 * @param {object} data  Fields to update
 */
export async function updateAdmin(id, data) {
  const payload = {
    name: data.name.trim(),
    email: data.email.trim().toLowerCase(),
    role: data.role,
    updatedAt: new Date().toISOString(),
  };
  if (data.role !== 'admin') {
    payload.permissions = data.permissions;
  } else {
    // If upgrading to admin, delete/clear permissions field in Firestore
    payload.permissions = [];
  }
  // Only update password if a new one was provided
  if (data.password && data.password.trim()) {
    payload.password = data.password.trim();
  }
  await db.collection('admins').doc(id).update(payload);
}

/**
 * Delete an admin document by ID.
 * @param {string} id  Firestore document ID
 */
export async function deleteAdmin(id) {
  await db.collection('admins').doc(id).delete();
}
